"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var calculateNewProficiencyScore_1 = __importDefault(require("../calculateNewProficiencyScore"));
var calculateProficiencyPercentage_1 = __importDefault(require("../calculateProficiencyPercentage"));
var calculateNextReviewDate_1 = __importDefault(require("../calculateNextReviewDate"));
function calculateNewCardProgress(currentProgress, rating) {
    // Get the ratings of previous attmepts
    var pastRatings = currentProgress.attempts.map(function (attempt) { return attempt.rating; });
    // Get the rating of the attempt before this one
    var previousRating = pastRatings.slice(-1)[0] || null;
    // Calculate the new proficiency score
    var proficiency = calculateNewProficiencyScore_1.default(rating, pastRatings);
    // Calculate the new proficiency percentage
    var proficiencyPercentage = calculateProficiencyPercentage_1.default(proficiency);
    // Check if the card should be retired
    var shouldRetire = rating === 'retire' || proficiencyPercentage === 100;
    var progress = __assign(__assign({}, currentProgress), { proficiency: proficiency, retired: shouldRetire, nextReview: calculateNextReviewDate_1.default(rating, previousRating), attempts: __spread(currentProgress.attempts, [{ createdAt: new Date(), rating: rating }]) });
    return progress;
}
exports.default = calculateNewCardProgress;
//# sourceMappingURL=calculateNewCardProgress.js.map